import React from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import PageHero from './Component/PageHero';
import home2 from './Component/s3.png';
import s2 from './Component/s2.png';

const services = [
  { label: 'Custom area rugs', href: '/custom-area-rugs' },
  { label: 'Area rug binding' },
  { label: 'Carpet binding' },
  { label: 'Carpet disposal' },
  { label: 'Carpet re-stretch' },
  { label: 'Commercial installations' },
  { label: 'Flooring repairs' },
  { label: 'Hardwood refinishing' },
  { label: 'Residential installation' },
  { label: 'Commercial installation' },
  { label: 'Mobile showroom' },
  { label: 'Subfloor repair' },
  { label: 'Underlayment' },
];

function Services() {
  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />
      <PageHero
        eyebrow="What we offer"
        title="Services"
        subtitle="See why we're the San Rafael, CA area's most trusted service provider"
      />

      <section className="pb-12 md:pb-20">
        <div className="mx-auto grid max-w-6xl items-start gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:gap-12 lg:px-8">
          <div className="overflow-hidden rounded-[1.75rem]">
            <img src={home2} alt="Flooring services" className="h-full w-full object-cover" />
          </div>
          <div className="rounded-[1.75rem] bg-white p-6 shadow-sm ring-1 ring-slate-200/80 sm:p-8">
            <ul className="space-y-1">
              {services.map((item) => (
                <li key={item.label}>
                  {item.href ? (
                    <a
                      href={item.href}
                      className="flex items-center justify-between rounded-xl px-3 py-2.5 text-sm font-medium text-slate-700 no-underline transition hover:bg-[#0075ca]/5 hover:text-[#0075ca] sm:text-base"
                    >
                      {item.label}
                      <span className="text-xs font-semibold text-[#0075ca]">Learn more</span>
                    </a>
                  ) : (
                    <span className="block rounded-xl px-3 py-2.5 text-sm font-medium text-slate-700 sm:text-base">
                      {item.label}
                    </span>
                  )}
                </li>
              ))}
            </ul>
            <a
              href="/free-estimate"
              className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-[#0075ca] px-5 py-3 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad] sm:w-auto sm:text-base"
            >
              Request an estimate
            </a>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-6xl px-4 sm:px-6 lg:px-8">
          <a href="/financing" className="block overflow-hidden rounded-[1.75rem]">
            <img src={s2} alt="Financing options" className="w-full object-cover" />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Services;
